// Phase 85.A.239 — Admin menu catalog (FE mirror của backend menu_catalog.py).
// Dùng để map path → menu code cho ProtectedRoute + gate menu trong AdminLayout.
// Thêm menu mới: thêm 1 dòng ở đây + ở backend menu_catalog.py (cùng code).

export const ADMIN_MENU_PATHS = [
  { code: "dashboard", path: "/admin/dashboard" },
  { code: "tournaments", path: "/admin/tournaments" },
  { code: "players", path: "/admin/users" },
  { code: "audit_logs", path: "/admin/audit-logs" },
  { code: "match_health", path: "/admin/match-health" },
  { code: "payment_template", path: "/admin/settings/payment-template" },
  { code: "elo", path: "/admin/elo" },
  { code: "led_broadcast", path: "/admin/led-broadcast" },
  { code: "livestream_mgr", path: "/admin/livestream" },
  { code: "error_reports", path: "/admin/error-reports" },
  { code: "support_tickets", path: "/admin/support-tickets" },
  { code: "admin_kb", path: "/admin/messages/knowledge" },
  { code: "admin_messages", path: "/admin/messages" },
  { code: "settings_users_duplicates", path: "/admin/settings/users/duplicates" },
  { code: "settings_users", path: "/admin/settings/users" },
  { code: "settings_perms", path: "/admin/settings/permissions" },
  { code: "settings_venues", path: "/admin/settings/venues" },
  { code: "settings_emails", path: "/admin/settings/emails" },
  { code: "settings_karinox", path: "/admin/settings/karinox" },
  { code: "settings_telegram_webhook", path: "/admin/settings/telegram-webhook" },
  { code: "branding", path: "/admin/branding" },
  { code: "settings_refactor", path: "/admin/settings/refactor" },
  { code: "settings_backups", path: "/admin/settings/backups" },
  { code: "hls_jobs", path: "/admin/system/hls-jobs" },
  { code: "query", path: "/admin/query" },
  { code: "security", path: "/admin/security" },
  { code: "cloudflare_iac", path: "/admin/cloudflare" },
  { code: "content_reports", path: "/admin/content-reports" },
];

// Codes KHÔNG nằm trong catalog quyền-menu (gate theo role như cũ).
export const NON_MENU_CODES = new Set([
  "switch_athlete",
  "switch_referee",
  "tournaments_parent",
  "players_parent",
  "elo",
]);

// Phase 85.A.273 — Đường dẫn admin ĐẦU TIÊN mà user thực sự có quyền vào.
// Sửa bug 403: trước đây mọi user admin-tier bị đẩy CỨNG về /admin/dashboard,
// nhưng menu "dashboard" mặc định CHỈ super_admin → organizer/admin/staff (và
// cả user kèm role athlete nhưng có quyền admin) rơi vào ProtectedRoute →
// 403 (kẹt vòng lặp vì nút "Về Tổng quan" cũng trỏ /admin/dashboard).
// Helper trả về menu đầu tiên trong menu_access (vd organizer → /admin/tournaments).
// Trả null nếu user KHÔNG có menu admin nào (vd VĐV thuần) → caller tự fallback.
export function firstAccessibleAdminPath(user) {
  const roles = user?.roles || [];
  if (roles.includes("super_admin")) return "/admin/dashboard";
  const access = user?.menu_access || [];
  if (access.includes("dashboard")) return "/admin/dashboard";
  for (const m of ADMIN_MENU_PATHS) {
    if (access.includes(m.code)) return m.path;
  }
  return null;
}

// Phase 85.A.276 — Danh sách "khu vực làm việc" (workspace) mà user có thể
// chuyển tới từ trang chủ VĐV. Dùng cho floating switcher + RootRedirect default.
// Thứ tự ưu tiên: Admin/BTC/CTV (theo menu) → Trọng tài → CTV theo giải được giao.
//   • super_admin/admin/staff (có menu) → "Trang Quản trị"
//   • organizer (có menu)               → "Trang BTC"
//   • publisher / khác (có menu)        → "Trang CTV"
//   • referee                           → "Trang Trọng tài" (/referee)
//   • chỉ được gán quyền theo giải       → "Trang CTV (giải được giao)" → chi tiết giải
export function userWorkspaces(user) {
  if (!user) return [];
  const roles = user.roles || [];
  const out = [];
  const adminPath = firstAccessibleAdminPath(user);
  const isHighAdmin = roles.some((r) => ["super_admin", "admin", "staff"].includes(r));
  const isOrganizer = roles.includes("organizer");
  if (adminPath) {
    if (isHighAdmin) out.push({ key: "admin", label: "Trang Quản trị", to: adminPath });
    else if (isOrganizer) out.push({ key: "btc", label: "Trang BTC", to: adminPath });
    else out.push({ key: "ctv", label: "Trang CTV", to: adminPath });
  }
  if (roles.includes("referee")) {
    out.push({ key: "referee", label: "Trang Trọng tài", to: "/referee" });
  }
  const assigned = user.assigned_tournament_ids || [];
  if (!adminPath && assigned.length > 0) {
    out.push({ key: "ctv", label: "Trang CTV (giải được giao)", to: `/admin/tournaments/${assigned[0]}` });
  }
  return out;
}

// Map 1 pathname → menu code theo longest-prefix. null nếu không khớp.
export function codeForPath(pathname) {
  let best = null;
  let bestLen = -1;
  for (const m of ADMIN_MENU_PATHS) {
    if (pathname === m.path || pathname.startsWith(m.path + "/") || pathname.startsWith(m.path)) {
      if (m.path.length > bestLen) {
        bestLen = m.path.length;
        best = m.code;
      }
    }
  }
  return best;
}

// Phase 85.A.275 (2a) — Trích tournament id từ path admin chi tiết giải
// (/admin/tournaments/{id} hoặc /admin/tournaments/{id}/edit). Trả null nếu là
// trang danh sách (/admin/tournaments) hoặc /admin/tournaments/create.
export function tournamentDetailId(pathname) {
  const m = /^\/admin\/tournaments\/([^/?#]+)/.exec(pathname || "");
  if (!m) return null;
  const id = m[1];
  if (id === "create") return null;
  return id;
}
